var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Banner'),_c('div',{staticClass:"m-main"},[_c('Industry')],1),_c('Nav',{attrs:{"navArr":_vm.NavDatas}}),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }